import { Maybe, nothing } from 'maybeasy';
import React from 'react';

export type PlatformWrapperRef = React.RefObject<HTMLDivElement | null>;

type PlatformWrapper = Maybe<PlatformWrapperRef>;

const PlatformWrapperContext = React.createContext<PlatformWrapper>(nothing());

export default PlatformWrapperContext;
